import commonDefaultState from './common'
import presentationDefaultState from './presentation'
import slideActiveDefaultState from './slideActive'
import teamDefaultState from './team'
import folderDefaultState from './folder'
import socketDefaultState from './socket'
import pricingDefaultState from './pricing'
import modalDefaultState from './modal'
import uploadDefaultState from './upload'
import currentUserDefaultState from './currentUser'
import routeDefaultState from './route'

export default {
  ...commonDefaultState,
  ...presentationDefaultState,
  ...slideActiveDefaultState,
  ...teamDefaultState,
  ...folderDefaultState,
  ...socketDefaultState,
  ...pricingDefaultState,
  ...modalDefaultState,
  ...uploadDefaultState,
  ...currentUserDefaultState,
  ...routeDefaultState,
}
